export const userInputs = [
    {
      id: "username",
      label: "Username",
      type: "text",
      placeholder: "akash",
    },
    
    {
      id: "email",
      label: "Email",
      type: "email",
      placeholder: "akash@gmail.com",
    },
    {
      id: "phone",
      label: "Phone",
      type: "text",
      placeholder: "+1 234 567 89",
    },
    {
      id: "password",
      label: "Password",
      type: "password",
    },
    {
      id: "country",
      label: "Country",
      type: "text",
      placeholder: "Bangladesh",
    },
    {
      id: "city",
      label: "City",
      type: "text",
      placeholder: "Dhaka",
    },
    // {
    //   id: "isAdmin",
    //   label: "Admin",
    //   type: "boolean",
    // },
  ];
  
  export const hotelInputs = [
    {
      id: "name",
      label: "Name",
      type: "text",
      placeholder: "Hotel Name",
    },
    {
      id: "type",
      label: "Type",
      type: "text",
      placeholder: "Type",
    },
    {
      id: "city",
      label: "City",
      type: "text",
      placeholder: "Dhaka",
    },
    {
      id: "address",
      label: "Address",
      type: "text",
      placeholder: "Shahbag",
    },
    {
      id: "distance",
      label: "Distance",
      type: "text",
      placeholder: "500",
    },
    {
      id: "title",
      label: "Title",
      type: "text",
      placeholder: "The best hotel",
    },
    {
      id: "description",
      label: "Description",
      type: "text",
      placeholder: "This hotel is very good.",
    },
    {
      id: "cheapestPrice",
      label: "Cheapest Price",
      type: "text",
      placeholder: "200",
    },
  ];

  export const roomInputs = [
    {
      id: "title",
      label: "Title",
      type: "text",
      placeholder: "2 bed room",
    },
    {
      id: "desc",
      label: "Description",
      type: "text",
      placeholder: "King size bed, 1 bathroom",
    },
    {
      id: "price",
      label: "Price",
      type: "number",
      placeholder: "100",
    },
    {
      id: "maxPeople",
      label: "Max People",
      type: "number",
      placeholder: "2",
    },
  ];
  